import { ADD_RECENT_HISTORY, RecentHistoryAction } from '../types';
export const addRecentHistory = (QID: string, name: string): RecentHistoryAction => ({
  type: ADD_RECENT_HISTORY,
  newRecent: { QID, name },
});
